import React from "react";
import DOMPurify from "isomorphic-dompurify";

/**
 * HTMLBubble Component
 * Renders sanitized HTML content from LLM responses
 */
const HTMLBubble = ({ html }) => {
  try {
    if (!html) {
      console.warn("HTMLBubble: Received empty html");
      return null;
    }

    // Configure DOMPurify to only allow safe tags
    const sanitized = DOMPurify.sanitize(html, {
      ALLOWED_TAGS: ["p", "strong", "em", "u", "br", "ul", "li", "img"],
      ALLOWED_ATTR: ["src", "alt"],
      ALLOW_DATA_ATTR: false,
    });

    if (!sanitized) {
      console.warn("HTMLBubble: Sanitization resulted in empty string");
      return null;
    }

    return (
      <div
        className="html-bubble structured-html"
        dangerouslySetInnerHTML={{ __html: sanitized }}
      />
    );
  } catch (error) {
    console.error("HTMLBubble: Error rendering HTML", error);
    console.error("HTML content:", html);
    return (
      <div className="html-bubble structured-html structured-error">
        <p>Error rendering content</p>
      </div>
    );
  }
};

export default HTMLBubble;
